import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import CreateButton from './creation/button';

export function DealsHeader({ listings, path, onNewDeal }) {
  return <React.Fragment>
    <div>
      <h2 className="pull-left">Deals</h2>
      <div className="pull-right">
        <CreateButton {...listings} path={path} onNewDeal={onNewDeal} />
      </div>
    </div>
    <div className="clearfix" />
    <hr className="mt-0" />
  </React.Fragment>;
}

DealsHeader.propTypes = {
  listings: PropTypes.object,
  path: PropTypes.string.isRequired,
  onNewDeal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  listings: state.dealsTab.listings,
});

export default connect(mapStateToProps)(DealsHeader);
